export default __webpack_public_path__ + "static/media/review-default.b4ab7a03.jpeg";